/**
 * Metadata for PostHog SPA events ($pageview, route_change).
 * Centralized so $pageview and route_change stay aligned.
 */

export type PostHogRouteMeta = { route_type: string; slug?: string };

/** Map pathname to route_type + slug for funnels and breakdowns. */
export function extractPostHogRouteMeta(pathname: string): PostHogRouteMeta | null {
  const vipMatch = pathname.match(/^\/vip\/([^/]+)/);
  if (vipMatch) return { route_type: "vip", slug: vipMatch[1] };

  const pMatch = pathname.match(/^\/p\/([^/]+)/);
  if (pMatch) return { route_type: "product", slug: pMatch[1] };

  const buyMatch = pathname.match(/^\/buy\/([^/]+)/);
  if (buyMatch) return { route_type: "direct_checkout", slug: buyMatch[1] };

  const reelMatch = pathname.match(/^\/reel\/([^/]+)/);
  if (reelMatch) return { route_type: "reel", slug: reelMatch[1] };

  const giftMatch = pathname.match(/^\/gift\/([^/]+)/);
  if (giftMatch) return { route_type: "gift", slug: giftMatch[1] };

  if (pathname.startsWith("/invitacion-premium")) {
    const tail =
      pathname.slice("/invitacion-premium".length).replace(/^\//, "") || "landing";
    return { route_type: "premium_invite", slug: tail };
  }

  return null;
}
